(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-info-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Initialize all info cards carousels on the page
    const carousels = document.querySelectorAll('.rtnu-info-cards-carousel');

    carousels.forEach((emblaNode) => {
      if (emblaNode._emblaInfoCardsInitialized) return; // Prevent double initialization

      const viewport = emblaNode.querySelector('.embla__viewport');
      const dotsContainer = emblaNode.querySelector('.embla__dots');

      if (!viewport) return;

      // Responsive options for different behavior on desktop vs mobile
      const isDesktop = window.innerWidth > 768;
      const options = {
        align: 'start',
        containScroll: 'trimSnaps',
        slidesToScroll: isDesktop ? 'auto' : 1,
      };

      // Initialize Embla
      const embla = EmblaCarousel(viewport, options);

      // Check if scrolling is needed and add has-scrolling class
      const updateScrollingState = () => {
        const canScrollPrev = embla.canScrollPrev();
        const canScrollNext = embla.canScrollNext();
        const needsScrolling = canScrollPrev || canScrollNext;

        // Add/remove class for CSS styling
        if (needsScrolling) {
          emblaNode.classList.add('has-scrolling');
        } else {
          emblaNode.classList.remove('has-scrolling');
        }
      };

      // Pagination dots functionality
      const createDots = () => {
        if (!dotsContainer) return;

        const scrollSnaps = embla.scrollSnapList();
        const snapCount = scrollSnaps.length;
        dotsContainer.innerHTML = '';

        for (let i = 0; i < snapCount; i++) {
          const dot = document.createElement('button');
          dot.className = 'embla__dot';
          dot.type = 'button';
          dot.setAttribute('aria-label', `Go to page ${i + 1}`);
          dot.addEventListener('click', () => embla.scrollTo(i));
          dotsContainer.appendChild(dot);
        }
      };

      const updateDots = () => {
        if (!dotsContainer) return;

        const dots = dotsContainer.querySelectorAll('.embla__dot');
        const selectedIndex = embla.selectedScrollSnap();

        dots.forEach((dot, index) => {
          dot.classList.toggle('is-selected', index === selectedIndex);
        });
      };

      // Initialize dots and update on select
      embla.on('init', () => {
        createDots();
        updateDots();
        updateScrollingState();
      });

      embla.on('select', () => {
        updateDots();
        updateScrollingState();
      });

      // Handle resize with debounce
      let resizeTimer;
      const handleResize = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          // Update options based on new screen size
          const isDesktop = window.innerWidth > 768;
          const newOptions = {
            align: 'start',
            containScroll: 'trimSnaps',
            slidesToScroll: isDesktop ? 'auto' : 1,
          };
          embla.reInit(newOptions);
          createDots();
          updateDots();
          updateScrollingState();
        }, 150);
      };

      window.addEventListener('resize', handleResize);

      // Cleanup function
      const cleanup = () => {
        window.removeEventListener('resize', handleResize);
        if (embla) embla.destroy();
      };

      // Store cleanup function and mark as initialized
      emblaNode._emblaInfoCardsCleanup = cleanup;
      emblaNode._emblaInfoCardsInitialized = true;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
